import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE, TAB_IDS, TASK_TAB_IDS } from "./constants";

const iniState = {
  loadingParticipant: false,
  loadingTasks: false,
  tasks: {
    task_order: {},
    tasks: {
      due_next_7_days: [],
      due_this_month: [],
      past_due: []
    }
  },
  sessionId: null,
  contactId: null,
  accountId: null,
  loading: true,
  chairpersons: [],
  speakers: [],
  sponsors: [],
  moderators: [],
  exhibitors: [],
  tabs: [],
  selectedTab: TAB_IDS.DETAILS,
  isEditingDetails: false,
  contactData: {},
  editedContactData: {},
  //
  bio: {},
  values: {},
  fields: [],
  visibleFieldIds: [],
  lockedFieldIds: [],
  updatedFieldValues: {},
  hasUnSavedChangesModal: false,
  transitionToTabIdAfterSave: null,
  saving: false,
  selectedTaskTab: TASK_TAB_IDS.ALL
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    loadTasks: R.identity,
    save: R.identity,
    onCancel: R.identity,
    onCancelUnsavedChanges: R.identity,
    onConfirmUnsavedChanges: R.identity,
    selectParticipant: R.identity,
    setSelectedRecordData: (_, { payload }) => ({
      isEditingDetails: false,
      bio: payload.bio,
      values: payload.values,
      fields: payload.fields,
      visibleFieldIds: payload.visibleFieldIds,
      lockedFieldIds: payload.lockedFieldIds
    }),
    setUpdatedFieldValue: (state, { payload: { fieldId, value } }) => ({
      updatedFieldValues: {
        ...state.updatedFieldValues,
        [fieldId]: value
      }
    })
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
